<template>
  <div class="d-flex justify-content-center" id="google-reviews">
    <div class="row">
        <f-row>
            <f-col class="icon">
                <i class="fab fa-google icon review-icon"></i>
            </f-col>
            <f-col>
                <f-row>
                    <f-col class="text-center" v-if="!isLoading">
                        {{ ratingText }}, mit {{ rating }} von 5 Sternen
                    </f-col>
                    <f-col class="text-center" v-if="!isLoading">
                        <rating :rating="rating" />
                    </f-col>
                    <f-col class="text-center" v-else>
                        Lädt Bewertungen...
                    </f-col>
                </f-row>
            </f-col>
        </f-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleRating",
  props: {},
  data() {
    return {
      data: {},
      isLoading: true
    }
  },
  methods: {
    getRatings () {
      this.$storyapi.get ('cdn/stories/de-de/globals/google-rating', {})
          .then ((res) => {
            this.data = res.data.story.content.global['0']
            this.isLoading = false
          })
          .catch ((err) => {
            console.log (err)
          })
    },
  },
  computed: {
    rating: function () {
      return Number(this.data.rating)
    },
    ratingText: function () {
      return this.data.rating_text
    },
    text: function () {
      return this.data.text
    },

  },
  mounted() {
    this.getRatings()
  }
}
</script>

<style scoped>
.fa-google {
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}
</style>
